export function getNameAfterLastSlash(name?: string | null): string {
  if (!name) return "";

  const segments = name.split("/");
  return segments.length > 0 ? segments[segments.length - 1] : name;
}
